/**
 * This custom hook provides the functionality to save a user with the given parameters.
 */

import {useContext} from "react";
import generalConfig from "../../../../commons/associationStructure/generalConfig.json";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";

const useSelectablePlaylistFilters = () => {

    const {allowedAssociationStructure} = useContext(FirebaseAuthContext);

    const getSelectableAssociations = () => {
        return Object.keys(allowedAssociationStructure)
    }

    const getSelectableDisciplines = (associationsFilter) => {
        const disciplineList = []
        getSelectableAssociations()
            .filter((a) => associationsFilter.length === 0 || associationsFilter.find((aFilter) => aFilter.id === a))
            .forEach((association) => {
                disciplineList.push(...allowedAssociationStructure[association].disciplines)
            })

        // Remove the duplicates
        const duplicateFreeList = []
        disciplineList.forEach((discipline) => {
            if (!duplicateFreeList.includes(discipline)) {
                duplicateFreeList.push(discipline)
            }
        })

        return duplicateFreeList
    }

    const getSelectableMainFocuses = (associationsFilter, disciplineFilter) => {
        const mainFocusList = []

        getSelectableDisciplines(associationsFilter)
            .filter((d) => disciplineFilter.length === 0 || disciplineFilter.find((dFilter) => dFilter.id === d.name))
            .forEach((d) => {
                mainFocusList.push(...d.mainFocus)
            })

        // Remove the duplicates
        const duplicateFreeList = []
        mainFocusList.forEach((mainFocus) => {
            if (!duplicateFreeList.includes(mainFocus)) {
                duplicateFreeList.push(mainFocus)
            }
        })

        return duplicateFreeList
    }

    const getSelectableDifficulties = () => {
        return generalConfig.difficulty
    }

    const getSelectableAssociationItems = () => {
        return getSelectableAssociations().map((a) => {
            return {
                id: a,
                name: a
            }
        })
    }

    const getSelectableDisciplineItems = (associationsFilter) => {
        return getSelectableDisciplines(associationsFilter).map((d) => {
            return {
                id: d.name,
                name: d.name
            }
        })
    }

    const getSelectableMainFocusItems = (associationsFilter, disciplineFilter) => {
        return getSelectableMainFocuses(associationsFilter, disciplineFilter).map((m) => {
            return {
                id: m,
                name: m
            }
        })
    }

    const getSelectableDifficultyItems = () => {
        return getSelectableDifficulties().map((d) => {
            return {
                id: d,
                name: d
            }
        })
    }


    return {
        getSelectableAssociationItems,
        getSelectableDisciplineItems,
        getSelectableMainFocusItems,
        getSelectableDifficultyItems
    }
}
export default useSelectablePlaylistFilters;